export enum WorkspaceDetailsTab {
  SETTINGS = 'settings',
  GROUPS = 'groups',
  DOCUMENTS = 'documents',
  DCC_FULFILLMENT = 'dccFulfillment',
  IBL = 'ibl',
}
